import React from 'react'
import MainLayout from '../../layout/MainLayout'
import AddNewsForm from '../../components/News/AddNewsForm'

const AddBlogPage = () => {
  return (
    <MainLayout>
        <AddNewsForm />
    </MainLayout>
  )
}

export default AddBlogPage